module.exports = __webpack_public_path__ + "img/applications_chart_grafic.2f14a918.svg";